module.exports = __webpack_public_path__ + "img/living.a4ecc9fe.png";